/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionAdapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_MERGE2_MISSION) {
                cleverapps.eventBus.trigger("updateExtraBar");
                Merge2.current.customers.forceRewardsUpdate();
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("remove", (mission) => {
            if (mission.getType() === Mission.TYPE_MERGE2_MISSION) {
                cleverapps.extraBar.removeIcon(Merge2MissionExtraBarIcon);

                if (Merge2.current) {
                    Merge2.current.customers.forceRewardsUpdate();
                }

                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.eventBus.on("updateExtraBar", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_MERGE2_MISSION);
            if (!mission || !mission.isRunning()) {
                return;
            }

            if (cleverapps.resolution.isVertical()) {
                cleverapps.extraBar.removeIcon(Merge2MissionExtraBarIcon, true);
            } else {
                cleverapps.extraBar.addIcon(Merge2MissionExtraBarIcon);
            }
        });
    }
};

cleverapps.whenAllInitialized(() => Merge2MissionAdapter.SubscribeToEvents());
